import Api from '../api'
import * as types from './types'

export const getInitInfo = ({dispatch, state}, result) => {
  dispatch(types.auth.GET_INITINFO, result)
}

export const getConfigInfo = ({dispatch, state}) => {
  dispatch(types.todo.GET_CONFIGINFO_REQ)
  return Api.getConfigInfo().then(response => {
    dispatch(types.todo.GET_CONFIGINFO, {info: response.data})
    return response.data
  }).catch(resp => {
    dispatch(types.todo.GET_CONFIGINFO_FAIL, {errorMsg: resp.data.message})
    return resp.data
  })
}

export const updateConfigInfo = ({dispatch, state}, data) => {
  dispatch(types.todo.UPDATE_CONFIGINFO_REQ)
  return Api.updateConfigInfo(data).then(response => {
    dispatch(types.todo.UPDATE_CONFIGINFO, {info: response.data})
    return response
  }).catch(resp => {
    dispatch(types.todo.UPDATE_CONFIGINFO_FAIL, {errorMsg: resp.data.message})
    return resp.data.message
  })
}

export const getTodos = ({dispatch, state}, result) => {
  dispatch(types.todo.GET_ALL_REQ)
  return Api.getTodos().then(response => {
    dispatch(types.todo.GET_ALL, {todos: response.data})
    return response.data
  }).catch(resp => {
    dispatch(types.todo.GET_PRODUCTS_FAIL, {errorMsg: resp.data.message})
    return resp.data
  })
}

export const createTodo = ({dispatch, state}, data) => {
  dispatch(types.todo.CREATE_REQ, data)
  return Api.createTodo({content: data}).then(response => {
    dispatch(types.todo.CREATE, {todo: response.data})
    return response
  }).catch(resp => {
    dispatch(types.todo.CREATE_FAIL, {errorMsg: resp.data.message})
    return resp.data.message
  })
}

export const updateTodo = ({dispatch, state}, id, data) => {
  dispatch(types.todo.UPDATE_REQ, id, data)
  return Api.updateTodo(id, data).then(response => {
    dispatch(types.todo.UPDATE, {todo: response.data, id})
    return response
  }).catch(resp => {
    dispatch(types.todo.UPDATE_FAIL, {errorMsg: resp.data.message})
    return resp.data.message
  })
}

export const deleteTodo = ({dispatch, state}, id) => {
  dispatch(types.todo.DELETE_REQ, id)
  return Api.deleteTodo(id).then(response => {
    dispatch(types.todo.DELETE, {id})
    return true
  }).catch(resp => {
    dispatch(types.todo.DELETE_FAIL, {errorMsg: resp.data.message})
    return resp.data.message
  })
}

export const updateTodosOrder = ({dispatch, state}, data) => {
  dispatch(types.todo.UPDATE_ORDER_REQ)
  return Api.updateTodoOrder({ids: data}).then(response => {
    dispatch(types.todo.UPDATE_ORDER, {todos: response.data})
    return true
  }).catch(resp => {
    dispatch(types.todo.UPDATE_ORDER_FAIL, {errorMsg: resp.data.message})
    return resp.data.message
  })
}

export const errorShowAction = ({dispatch, state}, errorInfo) => {
  dispatch(types.error.SHOW, errorInfo)
  setTimeout(() => {
    dispatch(types.error.HIDE)
  },3000)
}

export const setDocTitle = ({dispatch}, title, addCompanyName = false) => {
  dispatch(types.global.SET_TITLE, title, addCompanyName)
}

export const weChatAjax = () => {
  // 获取微信ticket
  return Api.wxAjax().then(response => {
    return response
  })
}

export const onMenuShareAppMessage = (title, url, content) => {
  wx.onMenuShareAppMessage({
    title: title, // 分享标题
    desc: content, // 分享描述
    link: url, // 分享链接
    imgUrl: 'https://oaaqymp5v.qnssl.com/todo/152icon.png', // 分享图标
    success: function() {
      // 用户确认分享后执行的回调函数
    },
    cancel: function() {
      // 用户取消分享后执行的回调函数
    }
  });
}

export const onMenuShareTimeline = (url, content) => {
  wx.onMenuShareTimeline({
    title: content, // 分享描述
    link: url, // 分享链接
    imgUrl: 'https://oaaqymp5v.qnssl.com/todo/152icon.png ', // 分享图标
    success: function() {
        // 用户确认分享后执行的回调函数
    },
    cancel: function() {
        // 用户取消分享后执行的回调函数
    }
  });
}

export const wxConfig = (resp) => {
  wx.config({
    debug: false,
    appId: resp.app_id,
    timestamp: resp.timestamp,
    nonceStr: resp.noncestr,
    signature: resp.signature,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
  });
}

export const wxReady = (func) => {
  wx.ready(func)
}


/** WEBPACK FOOTER **
 ** ./src/vuex/actions.js
 **/